// extracted by mini-css-extract-plugin
export default {"columns":"Courses_columns__+v3ld"};